import {
  assign,
  eq,
  includes,
  isEmpty,
  isNaN,
  isUndefined,
  negate,
  parseInt,
  pick,
  pickBy,
  transform,
} from 'lodash-es';
import {
  DEFAULT_PAGE,
  MAX_PAGE as MAX_PAGINATION_ELEMENTS,
} from '@is24at/react-pagination';
import {
  SearchParams,
  SearchParamsEnum,
  SortEnum,
  SortValues,
} from 'utils/enums';

const querySanitizers = {
  [SearchParamsEnum.page]: {
    patch: ({ page }: any) => {
      const parsedPage = parseInt(page);
      return isNaN(parsedPage) || parsedPage <= DEFAULT_PAGE
        ? undefined
        : `${Math.min(parsedPage, MAX_PAGINATION_ELEMENTS)}`;
    },
  },
  [SearchParamsEnum.sort]: {
    patch: ({ sort }: any) =>
      eq(sort, SortEnum.default) || !includes(SortValues, sort)
        ? undefined
        : sort,
  },
  [SearchParamsEnum.companyName]: {
    patch: ({ companyName }: any) =>
      isEmpty(companyName) ? undefined : companyName,
  },
  [SearchParamsEnum.zipCode]: {
    patch: ({ zipCode }: any) => (isEmpty(zipCode) ? undefined : zipCode),
  },
  [SearchParamsEnum.region]: {
    patch: ({ region }: any) => (isEmpty(region) ? undefined : region),
  },
  [SearchParamsEnum.spot]: {
    patch: ({ spot }: any) => (isEmpty(spot) ? undefined : spot),
  },
};

/**
 * Sanitizes the location query.
 */
const sanitize = (query: any) => {
  const allowedQueryParams = pick(query, SearchParams);
  const patchedQueryParams = transform(
    querySanitizers,
    (result: any, sanitizer: any, param: any) =>
      assign(result, {
        [param]: sanitizer.patch(query),
      }),
    {},
  );
  return pickBy(
    { ...allowedQueryParams, ...patchedQueryParams },
    negate(isUndefined),
  );
};

export default sanitize;
